
const time = {
    /**
     * 毫秒时间戳转秒级
     * @param {*} value 待转换值（毫秒时间戳）
     * @param {*} fallback 转换失败的兜底值，默认空字符串
     * @returns {number|string} 秒级时间戳 / 兜底值
     */
    convertMsToSec (value, fallback = '') {
        // 步骤1：过滤空值（null/undefined/''/0）
        if (!value) return fallback;
        // 步骤2：强制转为数字（处理字符串类型的时间戳，如 '1735689600000'）
        const numValue = Number(value);
        // 步骤3：校验是否为有效数字（排除 NaN/Infinity）
        if (isNaN(numValue) || !isFinite(numValue)) return fallback;
        // 步骤4：确保是整数时间戳（可选，根据业务需求）
        const intValue = Math.floor(Math.floor(numValue) / 1000);
        // 步骤5：转换为秒级
        return intValue;
    },

}

export default time;
